var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[
    'material-icons',
    _vm.iconColor ? 'color-' + _vm.color : '',
    _vm.iconwithText ? _vm.positioning : ''
  ],style:({ fontSize: ((_vm.size || 16) + "px") })},[_vm._v(_vm._s(("" + (_vm.iconName ? _vm.name : null)))+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b9d73de","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/base-material/BaseMaterial.vue
// module id = null
// module chunks = 